import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Request } from '../../../../../typings/Request.interface';
import APIMethodKeys from '../../client/APIMethodKeys';
import { RequestListFiltersProps } from '../../typings/RequestList.interface';
import { GlobalContext } from '../contexts/GlobalContext';
import useRefreshingList, { RefreshingListResult, RefreshListOptions } from './useRefreshingList';
export const formatRequestFiltersForAPI = (filters: RequestListFiltersProps, time_column: 'created_at' | 'ingested_at' = 'created_at') => {
  const formatted_filters: {
    [k: string]: any;
  } = {};
  if (typeof filters.date === 'object' && (filters.date.min || filters.date.max)) {
    formatted_filters[time_column] = {
      gte: filters.date.min,
      lte: filters.date.max
    };
  }
  if (filters.ignored_count?.min || filters.ignored_count?.max) {
    formatted_filters.ignored_count = {
      ...(filters.ignored_count.min ? {
        gte: parseInt(filters.ignored_count.min)
      } : {}),
      ...(filters.ignored_count.max ? {
        lte: parseInt(filters.ignored_count.max)
      } : {})
    };
  }
  if (filters.events_count?.min || filters.events_count?.max) {
    formatted_filters.events_count = {
      ...(filters.events_count.min ? {
        gte: parseInt(filters.events_count.min)
      } : {}),
      ...(filters.events_count.max ? {
        lte: parseInt(filters.events_count.max)
      } : {})
    };
  }
  if (filters.cli_events_count?.min || filters.cli_events_count?.max) {
    formatted_filters.cli_events_count = {
      ...(filters.cli_events_count.min ? {
        gte: parseInt(filters.cli_events_count.min)
      } : {}),
      ...(filters.cli_events_count.max ? {
        lte: parseInt(filters.cli_events_count.max)
      } : {})
    };
  }
  formatted_filters.next = filters.next;
  formatted_filters.prev = filters.prev;
  formatted_filters.search_term = filters?.search_term ?? undefined;
  formatted_filters.status = filters?.status ?? undefined;
  formatted_filters.headers = filters.request?.headers ?? undefined;
  formatted_filters.body = filters.request?.body ?? undefined;
  formatted_filters.path = filters.request?.path ?? undefined;
  formatted_filters.parsed_query = filters.request?.parsed_query ?? undefined;
  formatted_filters.source_id = !filters.source_id || filters.source_id.length === 0 ? undefined : filters.source_id;
  formatted_filters.bulk_retry_id = !filters.bulk_retry_id || filters.bulk_retry_id.length === 0 ? undefined : filters.bulk_retry_id;
  if (filters.rejection_cause) {
    formatted_filters.rejection_cause = !filters.rejection_cause || filters.rejection_cause.length === 0 ? undefined : filters.rejection_cause;
  }
  return formatted_filters;
};
export interface RequestListResult extends Omit<RefreshingListResult<Request>, 'models'> {
  requests: Request[];
}
const useRequestList = (filters, options) => {
  const $ = _c(6);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t0;
  if ($[0] !== filters) {
    t0 = formatRequestFiltersForAPI({
      ...filters
    }, "created_at");
    $[0] = filters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const formatted_filters = t0;
  let t1;
  if ($[2] !== options) {
    t1 = {
      progressive: true,
      ...options
    };
    $[2] = options;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const props = useRefreshingList(APIMethodKeys.requests.list, HookdeckAPI.requests.list, formatted_filters, "created_at", "desc", t1);
  let t2;
  if ($[4] !== props) {
    t2 = {
      requests: props.models,
      ...props
    };
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useRequestList;